import _ from "lodash";
import { LOAD_ALL_PRODUCTS } from "../constants/global";
export default (state = {}, action) => {
  switch (action.type) {
    case LOAD_ALL_PRODUCTS:
      return { ...state, ..._.mapKeys(action.payload, "codigo") };
    default:
      return state;
  }
};
